import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DataInputHeader } from './components/DataInputHeader';
import { DataInputWorkflow } from './components/DataInputWorkflow';
import { useOcrInputStore } from './store/ocrInputStore';

export const OcrDataInputPage: React.FC = () => {
    const { t } = useTranslation();
    const resetAll = useOcrInputStore(state => state.resetAll);

    useEffect(() => {
        return () => {
            resetAll();
        }
    }, []);

    return (
        <Box
            sx={{
                height: 'calc(100% - 24px)',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Typography variant="title" gutterBottom>{t('ocrDataInput.title', 'OCR Data Input')}</Typography>
            <DataInputHeader />
            <DataInputWorkflow />
        </Box>
    );
};